import React, { useState, useEffect } from 'react';

const FeatureFilter = ({ filters, onFilterChange }) => {
    const [localSearch, setLocalSearch] = useState(filters.search || '');

    useEffect(() => {
        setLocalSearch(filters.search || '');
    }, [filters.search]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (filters.search !== localSearch) {
                onFilterChange({ ...filters, search: localSearch });
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [localSearch, filters, onFilterChange]);

    const handleSearchChange = (e) => {
        setLocalSearch(e.target.value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        onFilterChange({ ...filters, [name]: value });
    };

    const handleClearFilters = () => {
        onFilterChange({
            search: '',
            feature: '',
            status: '',
            startDate: '',
            endDate: ''
        });
    };

    return (
        <div style={{ background: "#ffffff", borderRadius: "12px", padding: "20px", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)", marginBottom: "28px" }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', flexWrap: 'wrap' }}>
                <div className="audit-filter-group" style={{ flex: '1 1 200px' }}>
                    <label className="audit-filter-label" style={{ display: 'block', marginBottom: '8px', fontWeight: 600, color: '#374151', fontSize: '14px' }}>Search</label>
                    <div className="audit-search-wrapper" style={{ width: '100%' }}>
                        <input
                            type="text"
                            name="search"
                            className="audit-filter-input"
                            placeholder="userId, title, messageType"
                            value={localSearch}
                            onChange={handleSearchChange}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>

                <div className="audit-filter-group" style={{ flex: '1 1 150px' }}>
                    <label className="audit-filter-label" style={{ display: 'block', marginBottom: '8px', fontWeight: 600, color: '#374151', fontSize: '14px' }}>Feature</label>
                    <select
                        name="feature"
                        className="audit-filter-input"
                        value={filters.feature || ''}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                    >
                        <option value="">All Features</option>
                        <option value="birthday">Birthday</option>
                        <option value="bloodPressure">Blood Pressure</option>
                        <option value="mood">Mood</option>
                        <option value="steps">Steps</option>
                        <option value="water">Water</option>
                        <option value="bmi">BMI</option>
                        <option value="bloodSugar">Blood Sugar</option>
                        <option value="story">Story</option>
                        <option value="ai">AI</option>
                    </select>
                </div>

                <div className="audit-filter-group" style={{ flex: '1 1 150px' }}>
                    <label className="audit-filter-label" style={{ display: 'block', marginBottom: '8px', fontWeight: 600, color: '#374151', fontSize: '14px' }}>Status</label>
                    <select
                        name="status"
                        className="audit-filter-input"
                        value={filters.status || ''}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                    >
                        <option value="">All Statuses</option>
                        <option value="success">Success</option>
                        <option value="failed">Failed</option>
                        <option value="opened">Opened</option>
                        <option value="dismissed">Dismissed</option>
                    </select>
                </div>

                <div className="audit-filter-group user-api-date-range-section" style={{ flex: '0 0 auto', marginBottom: 0, padding: 0, boxShadow: 'none', background: 'transparent' }}>
                    <label className="user-api-date-range-label" style={{ display: 'block', marginBottom: '8px', fontWeight: 600, color: '#374151', fontSize: '14px' }}>Date Range</label>
                    <div className="user-api-date-range-inputs" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <input
                            type="date"
                            name="startDate"
                            value={filters.startDate || ''}
                            onChange={handleChange}
                            className="user-api-started-dateRange"
                            max={filters.endDate || undefined}
                        />
                        <span className="user-api-date-separator" style={{ fontWeight: 600, color: '#6c757d' }}>to</span>
                        <input
                            type="date"
                            name="endDate"
                            value={filters.endDate || ''}
                            onChange={handleChange}
                            className="user-api-ended-dateRange"
                            min={filters.startDate || undefined}
                        />
                    </div>
                </div>

                <div style={{ flex: '0 0 auto' }}>
                    <button 
                        className="btn btn-danger" 
                        style={{ padding: '8px 20px', borderRadius: '8px', fontWeight: 500, height: '40px', display: 'flex', alignItems: 'center' }} 
                        onClick={handleClearFilters}
                    >
                        Clear Filters
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeatureFilter;
